import { cn } from '@/lib/utils';

export type WarehouseSubTab = 'warehouse' | 'products';

interface WarehouseSubNavProps {
  activeSubTab: WarehouseSubTab;
  onSubTabChange: (tab: WarehouseSubTab) => void;
}

const tabs: { key: WarehouseSubTab; label: string }[] = [
  { key: 'warehouse', label: 'Almacén' },
  { key: 'products', label: 'Productos' },
];

const WarehouseSubNav = ({ activeSubTab, onSubTabChange }: WarehouseSubNavProps) => {
  return (
    <div className="border-b border-border">
      <nav className="flex gap-6" aria-label="Warehouse tabs">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => onSubTabChange(tab.key)}
            className={cn(
              'pb-3 text-sm font-medium transition-colors relative',
              activeSubTab === tab.key
                ? 'text-foreground'
                : 'text-muted-foreground hover:text-foreground'
            )}
          >
            {tab.label}
            {activeSubTab === tab.key && (
              <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-primary rounded-full" />
            )}
          </button>
        ))}
      </nav>
    </div>
  );
};

export default WarehouseSubNav;
